import React, { useState, useRef, useEffect } from 'react';
import { useNavigate, Link } from "react-router-dom";
import {
  Slide,
  IconButton,
  ClickAwayListener,
  InputBase,
  Button,
  Grid,
  Container,
  Stack,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
  Paper,
  Tabs,
  Tab,
  Box,
  Modal,
  Divider,
  MenuItem,
  FormControl,
  InputLabel,
  Select,
  TextField,
  FormControlLabel,
  RadioGroup,
  Radio,
  Checkbox,
  ListItemText,
  OutlinedInput,
  Pagination,
  CircularProgress,

  Avatar,
  InputAdornment,
  Card,
  CardContent,
  CardMedia,

} from '@mui/material';

import PaginationItem from '@mui/material/PaginationItem';

import Autocomplete, { createFilterOptions } from '@mui/material/Autocomplete';
import { styled } from '@mui/material/styles';
import { Document, Page, pdfjs } from 'react-pdf';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { CopyToClipboard } from 'react-copy-to-clipboard';
import CustomComplete from '../components/customComplete/CustomComplete';
import CustomCompleteWorksheet from '../components/customComplete/CustomCompleteWorksheet';
import Iconify from '../components/iconify';
// import Upload from '../components/upload';   
import Scrollbar from '../components/scrollbar/Scrollbar';

import { Api, UploadFile } from '../webservices';
import Header from './Header'
import Footer from './Footer'

const Blogs = () => {

  const navigate = useNavigate();

  const blogPostsLat = [
    {
      title: 'The Future of Tech: Trends to Watch in 2025',
      image: 'https://media.istockphoto.com/id/1225395022/photo/young-adult-working-from-home-during-covid-19-quarantine-lockdown.jpg?s=1024x1024&w=is&k=20&c=JDhkURQzlIDuE8l6N02j88h8FXWuhbbNysZ-5tD40Nw=',
      excerpt: 'Discover the emerging technologies that are set to shape the future.',
    },
    {
      title: 'How to Enhance Your Productivity',
      image: 'https://media.istockphoto.com/id/1326050425/photo/shot-of-a-young-women-telemarketer-and-it-support-worker-working-at-home-stock-photo.jpg?s=1024x1024&w=is&k=20&c=D-bDjWaHA7H7X_Dsj7kpPAOt4zmrnjNoWBd0JLlep3o=',
      excerpt: 'Tips and tricks to boost your productivity and achieve more.',
    },
    {
      title: 'Design Inspiration: Creating User-Centric Experiences',
      image: 'https://media.istockphoto.com/id/1307739367/photo/shot-of-a-young-woman-listening-music-by-using-headphone-at-home-stock-photo.jpg?s=1024x1024&w=is&k=20&c=SjQkMuFyGUmbqZDr5vgucPtLu4Qf3Dn05jL5IYEqHoI=',
      excerpt: 'Explore innovative design practices to improve user experiences.',
    },
  ];

  const blogPostsPop = [
    {
      title: 'Boost Recruitment Efficiency: How Foxearch Transforms Workflows with AI-Powered ATS',
      // image: 'https://media.istockphoto.com/id/926382468/photo/global-satellite-internet-service-concept-3d-rendering.jpg?s=1024x1024&w=is&k=20&c=R2nmMqBQhhipp5L2V_iiEBfHkSxq5IJyD4R08v0nf9E=',
      image: '/assets/ai_powered_blog.jpg',
      excerpt: 'Foxearch enhances recruitment efficiency by streamlining workflows and leveraging AI-driven technology. The platform eliminates duplicate candidate profiles by centralizing all data into one unified system, ensuring recruiters work with accurate and up-to-date information. It seamlessly integrates the Recruitment, Bench, and Sales modules, fostering collaboration across teams. Foxearch provides access to a vast candidate database, speeding up sourcing and reducing time-to-hire. Additionally, its AI-powered candidate mapping automatically matches candidates to the right jobs based on skills and experience. With a centralized information hub, recruiters can easily manage candidate profiles, job openings, and client communications, improving decision-making and productivity. Foxearch transforms the recruitment process, making it more efficient and effective.',
      content: `
       <h6>Key Features That Drive Recruitment Productivity</h6>
<ul>
  <li><strong>Eliminate Duplicate Candidate Profiles:</strong>
    Foxearch ensures that recruiters never waste valuable time working on duplicate candidate profiles. By centralizing all candidate data into a single, unified platform, Foxearch creates a reliable source of truth for your team. This eliminates redundancy, allowing for streamlined workflows and more efficient hiring processes.
  </li>
  <li><strong>Seamless Integration Across Recruitment, Bench, and Sales Modules:</strong>
    Foxearch seamlessly connects the Recruitment, Bench, and Sales modules, fostering better collaboration and workflow between departments. This integration allows teams to work cohesively, ensuring mutual support at every stage. For instance:
   
      <li><strong>Recruitment teams:</strong> can access Bench data to identify candidates ready for deployment.</li>
      <li><strong>Sales teams:</strong> can tap into recruitment insights to match available talent with client requirements.</li>
   
    This interconnected structure breaks down silos and drives productivity across the organization.
  </li>
  <li><strong>Access to an Extensive Database Network:</strong>
    Foxearch opens the door to an expansive Database Network, enabling quicker and more efficient candidate sourcing. With this powerful tool, you always have access to a diverse pool of qualified candidates, helping you reduce time-to-hire and significantly improve your placement success rates.
  </li>
  <li><strong>AI-Driven Candidate Mapping:</strong>
    Leveraging cutting-edge AI technology, Foxearch automatically matches candidates to job openings based on their skills, experience, and client specifications. This advanced mapping process eliminates manual sorting and ensures that candidates are seamlessly matched to the roles that best suit their capabilities.
  </li>
  <li><strong>Centralized Information Hub:</strong>
    Gone are the days of managing scattered spreadsheets and using multiple tools. Foxearch consolidates all your recruitment data—candidate profiles, job openings, and client communications—into one easy-to-use platform. This centralization saves time and enhances decision-making by providing a comprehensive, real-time overview of your entire recruitment pipeline.
  </li>
</ul>
<p>By harnessing the power of AI and integrated workflows, Foxearch not only optimizes your recruitment processes but also drives measurable improvements in efficiency and results.</p>

      `
    },
    {
      title: 'Revolutionize Workforce Management with Foxearch: The Ultimate Game-Changer for Business Productivity',
      // image: 'https://cdn.pixabay.com/photo/2016/12/31/21/22/discus-fish-1943755_1280.jpg',
      image: '/assets/workforce2.jpg',
      excerpt: 'As a business owner or founder, you know that managing your workforce efficiently goes beyond just effort. Foxearch advanced Applicant Tracking System (ATS) does more than just streamline recruitment; it transforms the way you manage resources, track performance, and align your team to drive continuous growth. By optimizing every recruiter\'s minute-to-minute tasks, Foxearch ensures that every action taken contributes to your company\'s long-term success and profitability.',

      content: `
    <h6>How Foxearch Maximizes Business Productivity</h6>
<ul>
  <li><strong>AI-Driven Insights for Smarter Hiring
:</strong> Foxearch's sophisticated AI tools automatically match candidates to the most appropriate roles based on their skills, experience, and client requirements. This eliminates time-consuming manual sorting, allowing your recruiters to make faster, smarter decisions that directly contribute to business productivity. With AI-driven insights, you're not just hiring more efficiently—you're strategically positioning your team to meet future demands and maximize profit.</li>

  <li><strong>Customizable Workflows for Efficient Task Management
:</strong> Foxearch empowers you to tailor your workflows to fit your specific business needs. With customizable worksheets, your recruiters can track tasks, deadlines, and priorities with precision. This ensures that every step of the recruitment process is optimized, freeing up valuable time and improving the efficiency of your team. Each task performed becomes a stepping stone toward greater organizational success, with measurable results directly tied to your company’s growth.</li>


  <li><strong>Actionable Dashboards for Real-Time Performance Tracking
:</strong> Foxearch provides intuitive dashboards that give you clear, actionable insights into your recruitment activities. With real-time performance metrics, you can track:</li>
  
   
  <li><strong>Individual team member performance:</strong> ensuring every recruiter is aligned with company goals.</li>


  <li><strong>Resource effectiveness :</strong> in filling roles helping you understand where to optimize resources for maximum impact.</li>


  <li><strong>Client engagement :</strong> and success rates so you can make data-driven decisions to improve client satisfaction and retention.</li>


<p>By visualizing key metrics in real-time, you’re always in control of your team’s performance, ensuring that every action contributes to the overall success of the business.</p>


  <li><strong>Sales Optimization System for On-Time Performance:</strong> One of the standout features of Foxearch is its Sales Optimization System—a tool designed to never let you forget important meetings, deadlines, or client follow-ups. By managing your sales and recruitment efforts in sync, Foxearch ensures that performance is always on track and goals are met on time. This system boosts efficiency and helps your team stay ahead of the curve, ultimately driving stronger client relationships and improved revenue outcomes.</li>


  <h6>Conclusion: Turning Every Recruiter’s Effort into Future Profit
</h6>
<p>
By utilizing Foxearch’s ATS, you're not just optimizing your workforce management; you're making a strategic investment in the future of your business. Every task performed by your recruiters is captured, streamlined, and aligned with long-term business objectives, ensuring that no effort goes to waste. Foxearch’s combination of AI-powered insights, customizable workflows, and real-time performance tracking allows your team to operate at peak efficiency. And with the Sales Optimization System, your business will always stay on top of client needs and performance goals
</p>
<p>
Foxearch transforms the way your business manages recruitment, improves efficiency, and drives profit. By empowering your team with the right tools, you’re setting your company up for success—today and in the future
</p>
  </ul>

      `
    },
    {
      title: 'Empowering Individual Recruiters: Foxearch is FREE – Forever',
      image: '/assets/workforce1.jpg',
      excerpt: 'Are you an independent recruiter looking to excel in a competitive market? Do you wish for a solution that simplifies your workflow without straining your budget? Look no further. Foxearch is dedicated to empowering individual recruiters by providing access to our state-of-the-art ATS—completely free, for life.',
      content: `
     
        <h6>Why Foxearch is Perfect for Individual Recruiters</h6>

<p>
At Foxearch, we understand that every recruiter, regardless of their size or financial capacity, should have access to the best tools available. We value the hard work and dedication that goes into the recruitment process and believe that individual recruiters should have the ability to automate and optimize their workflows. That’s why we've designed a unique plan that offers lifetime access to our platform’s core features—completely free of charge.

</P>
 <h6>What’s Included in the Free Plan?
</h6>
<ul>
  <li><strong>Unlimited Access to Core Features:</strong> Get full access to the essential tools that will enhance your recruitment process, from candidate tracking to job posting management.</li>
  <li><strong>AI-Powered Candidate Mapping:</strong> Save valuable time with our AI technology that automatically matches candidates to the right jobs, eliminating the need for manual searching and filtering.</li>
  <li><strong>Centralized Candidate Database:</strong> Keep all candidate profiles organized and easily accessible in one secure, centralized location.</li>
  <li><strong>Job Posting Management:</strong> Simplify the management of your jobs, ensuring consistency and reducing administrative overhead.</li>
  <li><strong>Basic Reporting and Analytics:</strong> Gain key insights into your performance with essential reporting tools, helping you make informed decisions and track progress.</li>
</ul>

  <h6>The Clear Benefits of Using Foxearch
</h6>

<ul>
  <li><strong>Cost Savings:</strong> Say goodbye to costly ATS subscriptions. Foxearch removes the financial burden, allowing you to invest your resources where they’ll have the most impact.</li>
  <li><strong>Increased Efficiency:</strong> By streamlining administrative tasks, you can focus more on what matters most—building meaningful relationships with clients and candidates.</li>
  <li><strong>Enhanced Candidate Management:</strong> With Foxearch, you’ll keep all your candidate data organized, easily accessible, and secure, ensuring nothing falls through the cracks.</li>
  <li><strong>Scalability:</strong> As your business grows, Foxearch grows with you. Our platform provides all the tools you need to scale without incurring additional costs.</li>
</ul>
<p>
We understand the unique challenges faced by individual recruiters, and we’re here to make your life easier. Foxearch is committed to supporting your success and ensuring that you have the tools to automate your workflow and improve efficiency—without the financial strain. Because your hard work deserves to be valued, we are proud to offer our platform <strong>free, forever.</strong>
</p>
      `
    },
  ];

  const [open, setOpen] = useState(false);
  const [selectedPostContent, setSelectedPostContent] = useState('');

  const handleOpen = (post) => {
    setSelectedPostContent(post);
    setOpen(true);
  };

  const handleClose = () => setOpen(false);

  return (
    <>
      {/* <Stack backgroundColor={'text.secondary'}>
        <Stack
          flexDirection={'row'}
          alignItems={'flex-end'}
          justifyContent={'space-between'}
          sx={{
            padding: 3, mt: 1.5, mb: 1.5,
            flexWrap: 'nowrap', alignItems: 'center'
          }}
        >
          <Stack flexDirection={'row'} gap={3} >
            <Typography color="white">
              Foxearch Icon
            </Typography>
            <Typography color="white" sx={{ ml: 11, cursor: 'pointer' }} onClick={() => navigate('/home')}>
              Home
            </Typography>
            <Typography color="white" sx={{ cursor: 'pointer' }} onClick={() => navigate('/contactUs')}>
              Contact Us
            </Typography>
          </Stack>

          <Stack
            flexDirection="row"
            gap={2}
            sx={{ flexWrap: 'nowrap', alignItems: 'center' }}
          >
            <Iconify icon="fontisto:world-o" width="2rem" color="white" sx={{ cursor: "pointer" }} />
            <Typography color="white" sx={{ cursor: "pointer", marginRight: 4 }} onClick={() => navigate('/login')}>Sign In</Typography>
            <Button
              sx={{
                backgroundColor: "white",
                '&:hover': {
                  backgroundColor: "white",
                }
              }}
            >
              Request Demo
            </Button>
          </Stack>
        </Stack>
        <Divider sx={{ borderColor: "white" }} />

        <Box
          sx={{
            backgroundSize: 'cover',
            backgroundPosition: 'center',
            color: '#fff',
            py: 8,
            textAlign: 'center'
          }}
        >
          <Container>
            <Typography variant="h2" gutterBottom>
              Our Blog
            </Typography>
            <Typography variant="h6">
              Insights, Stories, and Ideas to Inspire You
            </Typography>
          </Container>
        </Box>
      </Stack>

      <Container sx={{ mt: 4 }}>
        <Typography variant="h4" gutterBottom>
          Latest Posts
        </Typography>
        <Grid container spacing={4}>
          {blogPostsLat?.map((post, index) => (
            <Grid item xs={12} sm={6} md={4} key={index}>
              <Card
                sx={{
                  width: 370,
                  height: 410,
                  boxShadow: '0 4px 8px rgba(0, 0, 0, 0.2)',
                  transition: 'transform 0.3s, box-shadow 0.3s',
                  display: 'flex',
                  flexDirection: 'column',
                  justifyContent: 'space-between',
                  '&:hover': {
                    transform: 'translateY(-10px)',
                    boxShadow: '0 8px 16px rgba(0, 0, 0, 0.3)',
                  },
                }}
              >
                <CardMedia
                  component="img"
                  height="200"
                  image={post.image}
                  alt={post.title}
                  sx={{
                    objectFit: 'cover',
                  }}
                />
                <CardContent sx={{ flexGrow: 1 }}>
                  <Typography
                    variant="h6"
                    sx={{
                      fontWeight: 'bold',
                      overflow: 'hidden',
                      textOverflow: 'ellipsis',
                      display: '-webkit-box',
                      WebkitLineClamp: 2,
                      WebkitBoxOrient: 'vertical',
                    }}
                  >
                    {post.title}
                  </Typography>
                  <Typography
                    variant="body2"
                    color="textSecondary"
                    sx={{
                      mt: 1,
                      overflow: 'hidden',
                      textOverflow: 'ellipsis',
                      display: '-webkit-box',
                      WebkitLineClamp: 3,
                      WebkitBoxOrient: 'vertical',
                    }}
                  >
                    {post.excerpt}
                  </Typography>
                </CardContent>
                <Box sx={{ textAlign: 'center', pb: 2 }}>
                  <Button color="custom" type="submit" variant="contained" sx={{ mt: 1, mb: 1 }}>
                    Read More
                  </Button>
                </Box>
              </Card>

            </Grid>
          ))}
        </Grid>
      </Container>

      <Container sx={{ mt: 4 }}>
        <Typography variant="h4" gutterBottom>
          Popular Posts
        </Typography>
        <Grid container spacing={4}>
          {blogPostsPop?.map((post, index) => (
            <Grid item xs={12} sm={6} md={4} key={index}>
              <Card
                sx={{
                  width: 370,
                  height: 410,
                  boxShadow: '0 4px 8px rgba(0, 0, 0, 0.2)',
                  transition: 'transform 0.3s, box-shadow 0.3s',
                  display: 'flex',
                  flexDirection: 'column',
                  justifyContent: 'space-between',
                  '&:hover': {
                    transform: 'translateY(-10px)',
                    boxShadow: '0 8px 16px rgba(0, 0, 0, 0.3)',
                  },
                }}
              >
                <CardMedia
                  component="img"
                  height="200"
                  image={post.image}
                  alt={post.title}
                  sx={{
                    objectFit: 'cover',
                  }}
                />
                <CardContent sx={{ flexGrow: 1 }}>
                  <Typography
                    variant="h6"
                    sx={{
                      fontWeight: 'bold',
                      overflow: 'hidden',
                      textOverflow: 'ellipsis',
                      display: '-webkit-box',
                      WebkitLineClamp: 2,
                      WebkitBoxOrient: 'vertical',
                    }}
                  >
                    {post.title}
                  </Typography>
                  <Typography
                    variant="body2"
                    color="textSecondary"
                    sx={{
                      mt: 1,
                      overflow: 'hidden',
                      textOverflow: 'ellipsis',
                      display: '-webkit-box',
                      WebkitLineClamp: 3,
                      WebkitBoxOrient: 'vertical',
                    }}
                  >
                    {post.excerpt}
                  </Typography>
                </CardContent>
                <Box sx={{ textAlign: 'center', pb: 2 }}>
                  <Button color="custom" type="submit" variant="contained" sx={{ mt: 1, mb: 1 }}>
                    Read More
                  </Button>
                </Box>
              </Card>

            </Grid>
          ))}
        </Grid>
      </Container>

      <Stack
        sx={{
          alignItems: 'center',
          py: 5,
          backgroundColor: '#003366',
          color: 'white',
          mt: 5,
        }}
      >
        <Typography variant="h4" gutterBottom>
          Stay Updated with Our Latest Posts
        </Typography>
        <Button
          variant="contained"
          sx={{
            backgroundColor: '#FF6600',
            '&:hover': { backgroundColor: '#E55D00' },
          }}
          // onClick={() => navigate('/subscribe')}
        >
          Subscribe Now
        </Button>
      </Stack> */}


      <div id="body" className="page-template page-template-page-templates page-template-full-width page-template-page-templatesfull-width-php page page-id-1277 wp-custom-logo theme-deepdigital woocommerce-no-js tribe-no-js page-template-deepdigital yith-wcbm-theme-deepdigital singular no-sidebar container-1170 meta-icons-main woo header-sticky animation-enabled elementor-default elementor-kit-2882 elementor-page elementor-page-1277" itemType="https://schema.org/WebPage" itemScope="itemscope" data-animate='{&quot;.footer-widgets .widget&quot;:&quot;fadeInUp&quot;}'>
        <div id="box" className="box-fade-in">
          <div id="top-wrap">
            <Header />
          </div>
          <section id="title" className="title title-3 text-center polygon l m fs-12 background-cover cover-center nw_tbar">
            <div className="container ">
              <h4 itemProp="headline" style={{ color: '#ed457a' }}>Blogs

              </h4>
              <h6 style={{ color: '#fff', 'margin-top': '20px' }}>
                <small>
                  Your Source for Hiring Success
                </small>
              </h6>
              <nav className="breadcrumbs">
                <span><span><Link to="/home">Home</Link></span> &bull; <span className="breadcrumb_last" aria-current="page">Blogs</span></span>
              </nav>
            </div>
          </section>

          <div id="main" className="main sidebar-25 sidebar-gap- width-inherit l">
            <div className="container pt-10 pb-10">
              <div id="columns" className="main-columns">
                <main id="col" className="column-main fs-16">
                  <div id="layout" className="layout-cols layout-cols-3 layout-gap-30">
                    {/* <div className="grid-columns-wrapper">
				<div className="masonry" style={{position: 'relative', height: '1317.97px'}}>
					<div className="grid-sizer"/>
				<div className="grid-item" style={{position: "absolute", left:" 0%", top: "0px"}}>
	<article id="post-9081" className="vertical-item content-padding big-padding with_background post-9081 post type-post status-publish format-standard has-post-thumbnail hentry category-web-design-blog-masonry tag-design" itemType="https://schema.org/Article" itemScope="itemscope">
					<div className="post-thumbnail-wrap">
								<figure className="post-thumbnail ">
					<a href="https://webdesign-finder.com/deepdigital-v2/post-format-standart-2-2-2/">
          <img
        {...{ fetchPriority: "high" }}
        width="1170"
        height="780"
        src="https://webdesign-finder.com/deepdigital-v2/wp-content/uploads/2023/02/img_33-1170x780.jpg"
        className="attachment-deepdigital-default-post size-deepdigital-default-post wp-post-image"
        alt="Deep Digital website sample post"
        itemProp="image"
        decoding="async"
        srcSet="
          https://webdesign-finder.com/deepdigital-v2/wp-content/uploads/2023/02/img_33-1170x780.jpg 1170w,
          https://webdesign-finder.com/deepdigital-v2/wp-content/uploads/2023/02/img_33-300x200.jpg 300w,
          https://webdesign-finder.com/deepdigital-v2/wp-content/uploads/2023/02/img_33-768x512.jpg 768w,
          https://webdesign-finder.com/deepdigital-v2/wp-content/uploads/2023/02/img_33-1024x683.jpg 1024w,
          https://webdesign-finder.com/deepdigital-v2/wp-content/uploads/2023/02/img_33-1536x1024.jpg 1536w,
          https://webdesign-finder.com/deepdigital-v2/wp-content/uploads/2023/02/img_33-765x510.jpg 765w,
          https://webdesign-finder.com/deepdigital-v2/wp-content/uploads/2023/02/img_33-400x267.jpg 400w,
          https://webdesign-finder.com/deepdigital-v2/wp-content/uploads/2023/02/img_33-600x400.jpg 600w,
          https://webdesign-finder.com/deepdigital-v2/wp-content/uploads/2023/02/img_33.jpg 1920w
        "
        sizes="(max-width: 1170px) 100vw, 1170px"
      /> 				</a>
				</figure>
			</div>
			
				<div className="item-content text-center">
						<span className="entry-date-wrap icon-inline">
				<span className="svg-icon icon-calendar"><svg xmlns="http://www.w3.org/2000/svg" width="448" height="512" viewBox="0 0 448 512">
	<path d="M152 24c0-13.3-10.7-24-24-24s-24 10.7-24 24V64H64C28.7 64 0 92.7 0 128v16 48V448c0 35.3 28.7 64 64 64H384c35.3 0 64-28.7 64-64V192 144 128c0-35.3-28.7-64-64-64H344V24c0-13.3-10.7-24-24-24s-24 10.7-24 24V64H152V24zM48 192h80v56H48V192zm0 104h80v64H48V296zm128 0h96v64H176V296zm144 0h80v64H320V296zm80-48H320V192h80v56zm0 160v40c0 8.8-7.2 16-16 16H320V408h80zm-128 0v56H176V408h96zm-144 0v56H64c-8.8 0-16-7.2-16-16V408h80zM272 248H176V192h96v56z"/>
</svg></span>					<a href="https://webdesign-finder.com/deepdigital-v2/post-format-standart-2-2-2/" rel="bookmark" itemProp="mainEntityOfPage">
										<span itemProp="datePublished">May 20, 2023</span>
					<span className="hidden" itemProp="dateModified">May 20, 2023</span>
										</a>
							</span>
			
										<header className="entry-header entry-header-small">
					<h3 className="entry-title" itemProp="headline"><a href="https://webdesign-finder.com/deepdigital-v2/post-format-standart-2-2-2/" rel="bookmark">Sample post with image</a></h3>				</header>
						<div className="entry-content" itemProp="text">
				<p>T-bone turducken shoulder ham hock jerky shankle beef. Pastrami shoulder pork lion porchetta, pance ground round pig sirloin…</p>
			</div>
		</div>
	</article>
</div> 
<div className="grid-item" style={{position: "absolute", left: "33.332%", top: "0px"}}>
	<article id="post-9079" className="vertical-item content-padding big-padding with_background post-9079 post type-post status-publish format-gallery has-post-thumbnail hentry category-averticement-blog-masonry tag-averticement tag-design post_format-post-format-gallery" itemType="https://schema.org/Article" itemScope="itemscope">
					<div className="post-thumbnail-wrap"  style={{ minHeight: "239.989px" }}>
								<figure className="post-thumbnail ">
					<a href="https://webdesign-finder.com/deepdigital-v2/post-with-carousel-3-2/">
						<div className="flexslider"><div className="flex-viewport" style={{ overflow: "hidden", position: "relative" }}>
              <ul className="slides" 
             style={{
    width: "1200%",
    transitionDuration: "0.8s",
    transform: "translate3d(-719px, 0px, 0px)",
  }}>
                <li className="clone" aria-hidden="true" 
                style={{
                  width: "359.984px",
                  marginRight: "0px",
                  float: "left",
                  display: "block",
                }}
              >
                  <img src="https://webdesign-finder.com/deepdigital-v2/wp-content/uploads/2023/05/img_10.jpg" alt="Post With Carousel"
                  style={{ minHeight: "239.989px" }}
                   draggable="false" />
									</li>								<li 
                 style={{
                  width: "359.984px",
                  marginRight: "0px",
                  float: "left",
                  display: "block",
                }}
                  className="" data-thumb-alt=""><img src="https://webdesign-finder.com/deepdigital-v2/wp-content/uploads/2023/02/img_32-1170x660.jpg" alt="Post With Carousel" 
                  style={{ minHeight: "239.989px" }}
                  draggable="false" />
								</li>
																	<li data-thumb-alt="" style={{
    width: "359.984px",
    marginRight: "0px",
    float: "left",
    display: "block",
  }}
                                   className="flex-active-slide"><img src="https://webdesign-finder.com/deepdigital-v2/wp-content/uploads/2023/05/img_14.jpg" alt="Post With Carousel" draggable="false"  style={{ minHeight: "239.989px" }} />
									</li>
															<li data-thumb-alt="" style={{
    width: "359.984px",
    marginRight: "0px",
    float: "left",
    display: "block",
  }} 
                              className=""><img src="https://webdesign-finder.com/deepdigital-v2/wp-content/uploads/2023/05/img_11.jpg" alt="Post With Carousel" draggable="false"  style={{ minHeight: "239.989px" }} />
									</li>
															<li data-thumb-alt="" style={{
    width: "359.984px",
    marginRight: "0px",
    float: "left",
    display: "block",
  }}
                               className=""><img src="https://webdesign-finder.com/deepdigital-v2/wp-content/uploads/2023/05/img_10.jpg" alt="Post With Carousel"  style={{ minHeight: "239.989px" }} draggable="false" />
									</li>
						<li style={{
    width: "359.984px",
    marginRight: "0px",
    float: "left",
    display: "block",
  }} className="clone" aria-hidden="true"><img src="https://webdesign-finder.com/deepdigital-v2/wp-content/uploads/2023/02/img_32-1170x660.jpg" alt="Post With Carousel"  style={{ minHeight: "239.989px" }} draggable="false" />
								</li></ul></div><ol className="flex-control-nav flex-control-paging"><li><a href="#" className="">1</a></li><li><a href="#" className="flex-active">2</a></li><li><a href="#" className="">3</a></li><li><a href="#" className="">4</a></li></ol><ul className="flex-direction-nav"><li className="flex-nav-prev"><a className="flex-prev" href="#" tabIndex="-1">&lt;</a></li><li className="flex-nav-next"><a className="flex-next" href="#" tabIndex="-1">&gt;</a></li></ul></div><span className="svg-icon icon-camera"><svg xmlns="http://www.w3.org/2000/svg" xlinkHref="http://www.w3.org/1999/xlink" version="1.1" width="24" height="24" viewBox="0 0 24 24">
	<path d="M4,4H7L9,2H15L17,4H20A2,2 0 0,1 22,6V18A2,2 0 0,1 20,20H4A2,2 0 0,1 2,18V6A2,2 0 0,1 4,4M12,7A5,5 0 0,0 7,12A5,5 0 0,0 12,17A5,5 0 0,0 17,12A5,5 0 0,0 12,7M12,9A3,3 0 0,1 15,12A3,3 0 0,1 12,15A3,3 0 0,1 9,12A3,3 0 0,1 12,9Z"/>
</svg>
</span>					</a>
				</figure>
			</div>
		
				<div className="item-content text-center">
						<span className="entry-date-wrap icon-inline">
				<span className="svg-icon icon-calendar"><svg xmlns="http://www.w3.org/2000/svg" width="448" height="512" viewBox="0 0 448 512">
	<path d="M152 24c0-13.3-10.7-24-24-24s-24 10.7-24 24V64H64C28.7 64 0 92.7 0 128v16 48V448c0 35.3 28.7 64 64 64H384c35.3 0 64-28.7 64-64V192 144 128c0-35.3-28.7-64-64-64H344V24c0-13.3-10.7-24-24-24s-24 10.7-24 24V64H152V24zM48 192h80v56H48V192zm0 104h80v64H48V296zm128 0h96v64H176V296zm144 0h80v64H320V296zm80-48H320V192h80v56zm0 160v40c0 8.8-7.2 16-16 16H320V408h80zm-128 0v56H176V408h96zm-144 0v56H64c-8.8 0-16-7.2-16-16V408h80zM272 248H176V192h96v56z"/>
</svg></span>					<a href="https://webdesign-finder.com/deepdigital-v2/post-with-carousel-3-2/" rel="bookmark" itemProp="mainEntityOfPage">
										<span itemProp="datePublished">May 20, 2023</span>
					<span className="hidden" itemProp="dateModified">May 20, 2023</span>
										</a>
							</span>
										<header className="entry-header entry-header-small">
					<h3 className="entry-title" itemProp="headline"><a href="https://webdesign-finder.com/deepdigital-v2/post-with-carousel-3-2/" rel="bookmark">Post With Carousel</a></h3>				</header>
						<div className="entry-content" itemProp="text">
				<p>Is your marketing strategy looking a little lackluster or not driving the results you are looking for? While you may not need to scrap…</p>
			</div>
		</div>
	</article>
</div>
<div className="grid-item" style={{
    position: "absolute",
    left: "66.6639%",
    top: "0px",
  }}>
	<article id="post-9077" className="vertical-item content-padding big-padding with_background post-9077 post type-post status-publish format-video has-post-thumbnail hentry category-logo-design-blog-masonry tag-design post_format-post-format-video" itemType="https://schema.org/Article" itemScope="itemscope">
					<div className="post-thumbnail-wrap">
								<figure className="post-thumbnail ">
					<a href="https://www.youtube.com/watch?v=mcixldqDIEQ">
						<img width="1170" height="780" src="https://webdesign-finder.com/deepdigital-v2/wp-content/uploads/2023/05/img_18-1170x780.jpg" className="attachment-deepdigital-default-post size-deepdigital-default-post wp-post-image" alt="Sample post with YouTube video" itemProp="image" decoding="async" srcSet="https://webdesign-finder.com/deepdigital-v2/wp-content/uploads/2023/05/img_18-1170x780.jpg 1170w, https://webdesign-finder.com/deepdigital-v2/wp-content/uploads/2023/05/img_18-300x200.jpg 300w, https://webdesign-finder.com/deepdigital-v2/wp-content/uploads/2023/05/img_18-768x512.jpg 768w, https://webdesign-finder.com/deepdigital-v2/wp-content/uploads/2023/05/img_18-1024x683.jpg 1024w, https://webdesign-finder.com/deepdigital-v2/wp-content/uploads/2023/05/img_18-1536x1024.jpg 1536w, https://webdesign-finder.com/deepdigital-v2/wp-content/uploads/2023/05/img_18-765x510.jpg 765w, https://webdesign-finder.com/deepdigital-v2/wp-content/uploads/2023/05/img_18-400x267.jpg 400w, https://webdesign-finder.com/deepdigital-v2/wp-content/uploads/2023/05/img_18-600x400.jpg 600w, https://webdesign-finder.com/deepdigital-v2/wp-content/uploads/2023/05/img_18.jpg 1920w" sizes="(max-width: 1170px) 100vw, 1170px" />
            <span className="svg-icon icon-video">
              <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" >
	<path d="M13.4211 7.02541C14.193 7.45856 14.193 8.54144 13.4211 8.97459L4.73684 13.8476C3.96491 14.2807 3 13.7393 3 12.873L3 3.12704C3 2.26074 3.96491 1.7193 4.73684 2.15245L13.4211 7.02541Z" fill="white"/>
</svg>
</span>					</a>
				</figure>
			</div>
			
				<div className="item-content text-center">
						<span className="entry-date-wrap icon-inline">
				<span className="svg-icon icon-calendar"><svg xmlns="http://www.w3.org/2000/svg" width="448" height="512" viewBox="0 0 448 512">
	<path d="M152 24c0-13.3-10.7-24-24-24s-24 10.7-24 24V64H64C28.7 64 0 92.7 0 128v16 48V448c0 35.3 28.7 64 64 64H384c35.3 0 64-28.7 64-64V192 144 128c0-35.3-28.7-64-64-64H344V24c0-13.3-10.7-24-24-24s-24 10.7-24 24V64H152V24zM48 192h80v56H48V192zm0 104h80v64H48V296zm128 0h96v64H176V296zm144 0h80v64H320V296zm80-48H320V192h80v56zm0 160v40c0 8.8-7.2 16-16 16H320V408h80zm-128 0v56H176V408h96zm-144 0v56H64c-8.8 0-16-7.2-16-16V408h80zM272 248H176V192h96v56z"/>
</svg></span>					<a href="https://webdesign-finder.com/deepdigital-v2/post-format-video-youtube-2-2-2/" rel="bookmark" itemProp="mainEntityOfPage">
										<span itemProp="datePublished">May 20, 2023</span>
					<span className="hidden" itemProp="dateModified">May 20, 2023</span>
										</a>
							</span>
			
										<header className="entry-header entry-header-small">
					<h3 className="entry-title" itemProp="headline"><a href="https://webdesign-finder.com/deepdigital-v2/post-format-video-youtube-2-2-2/" rel="bookmark">Sample post with YouTube video</a></h3>				</header>
						<div className="entry-content" itemProp="text">
				<p>T-bone turducken shoulder ham hock jerky shankle beef. Pastrami shoulder pork lion porchetta, pance ground round pig…</p>
			</div>
		</div>
	</article>
</div>
<div className="grid-item"  style={{
    position: "absolute",
    left: "33.332%",
    top: "558.984px",
  }}>
	<article id="post-9075" className="bg_teaser text-center vertical-item content-padding big-padding post-9075 post type-post status-publish format-status has-post-thumbnail hentry category-custom-websites-web-design-blog-masonry post_format-post-format-status" itemType="https://schema.org/Article" itemScope="itemscope"  style={{
    backgroundImage: "url('https://webdesign-finder.com/deepdigital-v2/wp-content/uploads/2023/04/img_2-1170x780.jpg')",
  }}>
  <div className="bg_overlay"/>
					<div className="post-thumbnail-wrap">
								<figure className="post-thumbnail ">
					<a href="https://webdesign-finder.com/deepdigital-v2/post-format-status-2-2-2/">
						<img width="1170" height="780" src="https://webdesign-finder.com/deepdigital-v2/wp-content/uploads/2023/04/img_2-1170x780.jpg" className="attachment-deepdigital-default-post size-deepdigital-default-post wp-post-image" alt="Sample post format: status" itemProp="image" decoding="async" srcSet="https://webdesign-finder.com/deepdigital-v2/wp-content/uploads/2023/04/img_2-1170x780.jpg 1170w, https://webdesign-finder.com/deepdigital-v2/wp-content/uploads/2023/04/img_2-300x200.jpg 300w, https://webdesign-finder.com/deepdigital-v2/wp-content/uploads/2023/04/img_2-768x512.jpg 768w, https://webdesign-finder.com/deepdigital-v2/wp-content/uploads/2023/04/img_2-1024x683.jpg 1024w, https://webdesign-finder.com/deepdigital-v2/wp-content/uploads/2023/04/img_2-1536x1024.jpg 1536w, https://webdesign-finder.com/deepdigital-v2/wp-content/uploads/2023/04/img_2-765x510.jpg 765w, https://webdesign-finder.com/deepdigital-v2/wp-content/uploads/2023/04/img_2-400x267.jpg 400w, https://webdesign-finder.com/deepdigital-v2/wp-content/uploads/2023/04/img_2-600x400.jpg 600w, https://webdesign-finder.com/deepdigital-v2/wp-content/uploads/2023/04/img_2.jpg 1920w" sizes="(max-width: 1170px) 100vw, 1170px" />					</a>
				</figure>
			</div>
			
				<div className="item-content i">
						<span className="entry-date-wrap icon-inline">
				<span className="svg-icon icon-calendar">
          <svg xmlns="http://www.w3.org/2000/svg" width="448" height="512" viewBox="0 0 448 512">
	<path d="M152 24c0-13.3-10.7-24-24-24s-24 10.7-24 24V64H64C28.7 64 0 92.7 0 128v16 48V448c0 35.3 28.7 64 64 64H384c35.3 0 64-28.7 64-64V192 144 128c0-35.3-28.7-64-64-64H344V24c0-13.3-10.7-24-24-24s-24 10.7-24 24V64H152V24zM48 192h80v56H48V192zm0 104h80v64H48V296zm128 0h96v64H176V296zm144 0h80v64H320V296zm80-48H320V192h80v56zm0 160v40c0 8.8-7.2 16-16 16H320V408h80zm-128 0v56H176V408h96zm-144 0v56H64c-8.8 0-16-7.2-16-16V408h80zM272 248H176V192h96v56z"/>
</svg></span>					<a href="https://webdesign-finder.com/deepdigital-v2/post-format-status-2-2-2/" rel="bookmark" itemProp="mainEntityOfPage">
										<span itemProp="datePublished">May 20, 2023</span>
					<span className="hidden" itemProp="dateModified">May 20, 2023</span>
										</a>
							</span>
			
										<header className="entry-header entry-header-small">
					<h3 className="entry-title" itemProp="headline"><a href="https://webdesign-finder.com/deepdigital-v2/post-format-status-2-2-2/" rel="bookmark">Sample post format: status</a></h3>				</header>
						<div className="entry-content" itemProp="text">
				<p>Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna</p>
				<div className="entry-footer entry-footer-top mt-30 mb-30">
					<div className="icon-inline">
						Status					</div>
				</div>
			</div>
		</div>
	</article>
</div><div className="grid-item" style={{
    position: "absolute",
    left: "0%",
    top: "588.984px",
  }}>
	<article id="post-9073" className="vertical-item content-padding big-padding with_background post-9073 post type-post status-publish format-link hentry category-branding-blog-masonry tag-branding post_format-post-format-link" itemType="https://schema.org/Article" itemScope="itemscope">
				<div className="item-content text-center">
						<span className="entry-date-wrap icon-inline">
				<span className="svg-icon icon-calendar"><svg xmlns="http://www.w3.org/2000/svg" width="448" height="512" viewBox="0 0 448 512">
	<path d="M152 24c0-13.3-10.7-24-24-24s-24 10.7-24 24V64H64C28.7 64 0 92.7 0 128v16 48V448c0 35.3 28.7 64 64 64H384c35.3 0 64-28.7 64-64V192 144 128c0-35.3-28.7-64-64-64H344V24c0-13.3-10.7-24-24-24s-24 10.7-24 24V64H152V24zM48 192h80v56H48V192zm0 104h80v64H48V296zm128 0h96v64H176V296zm144 0h80v64H320V296zm80-48H320V192h80v56zm0 160v40c0 8.8-7.2 16-16 16H320V408h80zm-128 0v56H176V408h96zm-144 0v56H64c-8.8 0-16-7.2-16-16V408h80zM272 248H176V192h96v56z"/>
</svg></span>					<a href="https://webdesign-finder.com/deepdigital-v2/blockquote-2-2-2/" rel="bookmark" itemProp="mainEntityOfPage">
										<span itemProp="datePublished">May 20, 2023</span>
					<span className="hidden" itemProp="dateModified">May 20, 2023</span>
										</a>
							</span>
										<header className="entry-header entry-header-small">
					<h3 className="entry-title" itemProp="headline"><a href="https://webdesign-finder.com/deepdigital-v2/blockquote-2-2-2/" rel="bookmark">Sample post format: link</a></h3>				</header>
						<div className="entry-content" itemProp="text">
				<p>https://example.com/</p>
			</div>
		</div>
	</article>
</div>
<div className="grid-item" style={{
    position: "absolute",
    left: "66.6639%",
    top: "588.984px",
  }}
>
	<article id="post-9071" className="vertical-item content-padding big-padding with_background post-9071 post type-post status-publish format-chat has-post-thumbnail hentry category-design-blog-masonry tag-design post_format-post-format-chat" itemType="https://schema.org/Article" itemScope="itemscope">
					<div className="post-thumbnail-wrap">
								<figure className="post-thumbnail ">
					<a href="https://webdesign-finder.com/deepdigital-v2/post-format-chat-2-2-2/">
						<img width="1170" height="780" src="https://webdesign-finder.com/deepdigital-v2/wp-content/uploads/2023/04/img_8-1170x780.jpg" className="attachment-deepdigital-default-post size-deepdigital-default-post wp-post-image" alt="Sample post format: chat" itemProp="image" decoding="async" srcSet="https://webdesign-finder.com/deepdigital-v2/wp-content/uploads/2023/04/img_8-1170x780.jpg 1170w, https://webdesign-finder.com/deepdigital-v2/wp-content/uploads/2023/04/img_8-300x200.jpg 300w, https://webdesign-finder.com/deepdigital-v2/wp-content/uploads/2023/04/img_8-768x512.jpg 768w, https://webdesign-finder.com/deepdigital-v2/wp-content/uploads/2023/04/img_8-1024x683.jpg 1024w, https://webdesign-finder.com/deepdigital-v2/wp-content/uploads/2023/04/img_8-1536x1024.jpg 1536w, https://webdesign-finder.com/deepdigital-v2/wp-content/uploads/2023/04/img_8-765x510.jpg 765w, https://webdesign-finder.com/deepdigital-v2/wp-content/uploads/2023/04/img_8-400x267.jpg 400w, https://webdesign-finder.com/deepdigital-v2/wp-content/uploads/2023/04/img_8-600x400.jpg 600w, https://webdesign-finder.com/deepdigital-v2/wp-content/uploads/2023/04/img_8.jpg 1920w" sizes="(max-width: 1170px) 100vw, 1170px" />					</a>
				</figure>
			</div>
			
				<div className="item-content text-center">
						<span className="entry-date-wrap icon-inline">
				<span className="svg-icon icon-calendar"><svg xmlns="http://www.w3.org/2000/svg" width="448" height="512" viewBox="0 0 448 512">
	<path d="M152 24c0-13.3-10.7-24-24-24s-24 10.7-24 24V64H64C28.7 64 0 92.7 0 128v16 48V448c0 35.3 28.7 64 64 64H384c35.3 0 64-28.7 64-64V192 144 128c0-35.3-28.7-64-64-64H344V24c0-13.3-10.7-24-24-24s-24 10.7-24 24V64H152V24zM48 192h80v56H48V192zm0 104h80v64H48V296zm128 0h96v64H176V296zm144 0h80v64H320V296zm80-48H320V192h80v56zm0 160v40c0 8.8-7.2 16-16 16H320V408h80zm-128 0v56H176V408h96zm-144 0v56H64c-8.8 0-16-7.2-16-16V408h80zM272 248H176V192h96v56z"/>
</svg></span>					<a href="https://webdesign-finder.com/deepdigital-v2/post-format-chat-2-2-2/" rel="bookmark" itemProp="mainEntityOfPage">
										<span itemProp="datePublished">May 20, 2023</span>
					<span className="hidden" itemProp="dateModified">May 20, 2023</span>
										</a>
							</span>
			
										<header className="entry-header entry-header-small">
					<h3 className="entry-title" itemProp="headline"><a href="https://webdesign-finder.com/deepdigital-v2/post-format-chat-2-2-2/" rel="bookmark">Sample post format: chat</a></h3>				</header>
						<div className="entry-content" itemProp="text">
				<p className=""><strong>Sam:</strong> Salami chuck frankfurter fatback, jerky venison ham filet mignon pork chop beef.</p><p className=""><strong>George:</strong> Tenderloin pork belly short ribs burgdoggen strip steak, prosciutto brisket.</p>			</div>
		</div>
	</article>
</div>		
	</div>
			</div> */}

                    {/* <nav className="navigation pagination" aria-label="Posts pagination">
		<h2 className="screen-reader-text">Posts pagination</h2>
		<div className="nav-links"><span aria-current="page" className="page-numbers current">1</span>
<a className="page-numbers" href="https://webdesign-finder.com/deepdigital-v2/category/blog-masonry/page/2/">2</a>
<a className="next page-numbers" href="https://webdesign-finder.com/deepdigital-v2/category/blog-masonry/page/2/"><span className="screen-reader-text">Next page</span><span className="icon-inline"><span className="svg-icon icon-chevron-right"><svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
	<path d="M5.82 4.51C5.53833 4.13445 5.61445 3.60167 5.99 3.32C6.36555 3.03833 6.89833 3.11445 7.18 3.49L5.82 4.51ZM9.5 8L10.18 7.49C10.4067 7.79222 10.4067 8.20778 10.18 8.51L9.5 8ZM7.18 12.51C6.89833 12.8856 6.36555 12.9617 5.99 12.68C5.61445 12.3983 5.53833 11.8656 5.82 11.49L7.18 12.51ZM7.18 3.49L10.18 7.49L8.82 8.51L5.82 4.51L7.18 3.49ZM10.18 8.51L7.18 12.51L5.82 11.49L8.82 7.49L10.18 8.51Z"/>
</svg></span></span></a></div>
	</nav>  */}
                    <Container sx={{ mt: -9 }}>
                      {/* <Typography variant="h4" gutterBottom>
                        Popular Posts
                      </Typography> */}
                      <Grid container spacing={10}>
                        {blogPostsPop?.map((post, index) => (
                          <Grid item xs={12} sm={6} md={4} key={index}>
                            <Card
                              sx={{
                                width: "370px",
                                height: "610px",
                                boxShadow: '0 4px 8px rgba(0, 0, 0, 0.2)',
                                transition: 'transform 0.3s, box-shadow 0.3s',
                                display: 'flex',
                                flexDirection: 'column',
                                justifyContent: 'space-between',
                                '&:hover': {
                                  transform: 'translateY(-10px)',
                                  boxShadow: '0 8px 16px rgba(0, 0, 0, 0.3)',
                                },
                              }}
                            >
                              <CardMedia
                                component="img"
                                height="250"
                                image={post.image}
                                alt={post.title}
                                sx={{
                                  objectFit: 'cover',
                                }}
                              />
                              <CardContent sx={{ flexGrow: 1 }}>
                                {/* <Typography
                    variant="h6"
                    sx={{
                      fontWeight: 'bold',
                      overflow: 'hidden',
                      textOverflow: 'ellipsis',
                      display: '-webkit-box',
                      WebkitLineClamp: 2,
                      WebkitBoxOrient: 'vertical',
                    }}
                  >
                    {post.title}
                  </Typography> */}
                                <Typography
                                  variant="h6"
                                  color="textSecondary"
                                  sx={{
                                    fontWeight: 'bold',
                                    whiteSpace: 'normal',
                                    overflow: 'visible',
                                    textOverflow: 'unset',
                                    display: 'block',
                                  }}
                                >
                                  {post.title}
                                </Typography>

                                <Typography
                                  variant="body2"

                                  sx={{
                                    // mt: 0.2,
                                    overflow: 'hidden',
                                    textOverflow: 'ellipsis',
                                    display: '-webkit-box',
                                    WebkitLineClamp: 6,
                                    WebkitBoxOrient: 'vertical',
                                  }}
                                >
                                  {post.excerpt}
                                </Typography>
                              </CardContent>
                              <Box sx={{ textAlign: 'center', pb: 2 }}>
                                <Button color="custom" type="submit" variant="contained" sx={{ mb: 1, 'background-color': '#e64377' }} onClick={() => handleOpen(post)}>
                                  Read More
                                </Button>
                              </Box>
                            </Card>

                          </Grid>
                        ))}
                      </Grid>
                    </Container>
                  </div>
                </main>

              </div>
            </div>

          </div>
        </div>
        <Footer />
      </div>

      <div>

        <Modal
          open={open}
          onClose={handleClose}
          aria-labelledby="modal-title"
          aria-describedby="modal-description"
        >
          <Box
            sx={{
              position: 'absolute',
              top: '50%',
              left: '50%',
              transform: 'translate(-50%, -50%)',
              width: "70%",
              maxHeight: " 80%",
              bgcolor: 'background.paper',
              boxShadow: 24,
              p: 4,
              borderRadius: 2,
              overflow: 'auto',
            }}
          >
            <Box sx={{ mb:1, fontSize:"25px",color: '#3c6ba5','font-weight': '600'}} dangerouslySetInnerHTML={{ __html: selectedPostContent.title }}
            />
           <Typography
  
  // component="p"
  variant="body2"
  dangerouslySetInnerHTML={{ __html: selectedPostContent.excerpt }}
  sx={{
    // fontWeight: 'bold',  
    color: 'text.primary',
    // marginBottom: '8px',
  }}
/>
            <Box dangerouslySetInnerHTML={{ __html: selectedPostContent.content }}
            />
            
          </Box>


        </Modal>
      </div>

    </>
  );
};

export default Blogs;
